import { render, staticRenderFns } from "./WafRuleEdit.vue?vue&type=template&id=4ca7070e"
import script from "./WafRuleEdit.vue?vue&type=script&lang=js"
export * from "./WafRuleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports